module.exports = __webpack_public_path__ + "static/img/0010-4未启用吉林市人民政府.960331d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0010-4未启用吉林市人民政府.jpg
// module id = jUEb
// module chunks = 0